import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import type { TextFieldPropsWithEdit } from '@/types';

interface ManifestCheckSectionFieldProps extends TextFieldPropsWithEdit {
  isEditing?: boolean;
}

export default function ManifestCheckSectionField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
  isEditing = false,
}: ManifestCheckSectionFieldProps): React.JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('Check section cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else {
      setError(false);
    }
  };

  const is_blank = value === '';
  const helper_text = 'Enter the section of the governing document this check relates to (Use \'global\' for Doc Control checks)';
  const warning_text = 'Specifying a section is strongly recommended as it is used by the AI agent to identify the correct document section to analyze';

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Section'
          id='section'
          aria-describedby='section-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
          InputLabelProps={{ shrink: value?.length > 0 }}
        />
        {error ? (
          <FormHelperText id='section-helper-text' error>
            {error}
          </FormHelperText>
        ) : (
          <>
            <FormHelperText id='section-helper-text'>
              {helper_text}
            </FormHelperText>
            {is_blank && isEditing && (
              <FormHelperText id='section-warning-text' sx={{ color: 'warning.main' }}>
                {warning_text}
              </FormHelperText>
            )}
          </>
        )}
      </FormControl>
    </Box>
  );
}

